const initialState = localStorage.getItem("view") ? JSON.parse(localStorage.getItem("view")) : []

const viewReducer = (state = initialState, action) => {
    let {type, payload} = action;
    switch (type) {
        case "UPDATE_VIEW":
            localStorage.setItem("view", JSON.stringify(payload));
            return state;
        default:
            return state;
    }
};

export default viewReducer;